/* eslint-disable no-unused-expressions */
/******************************************************************************
 * TableView Hook
 * version: 1.0.1, release: 10.06.2019
 * author: albert lang, albert@jumptomorrow.com
 * ----------------------------------------------------------------------------
 * description:
 * 
 * dependencies: none
 * 
 * todos:
 * - allowUnselect
 * - cellRenderer
 * 
 * sample:
 * 
 * props:
 * 		header		:	boolean
 * 		selectable	:	boolean
******************************************************************************/

import React, { useState, useEffect, useRef } from 'react';
import './TableView.scss';


//============================================================================= TableView Hook
export default function TableView(props) {
	const [selected, setSelected] = useState(-1);
	const [data, setData] = useState([]);
	const cols = useRef(props.columns || []);

	const [setup] = useState(e => {
		let s = {};
		return s;
	})

	useEffect(() => {
		// console.log('---init TableView');
		return () => {};	//cleanup
	}, []);


	useEffect(() => {
		if (!props.source) return;
		let src = Array.isArray(props.source)? props.source : Object.values(props.source);
		if (!src) return setData([]);

		if (!cols.current.length && src[0]){
			cols.current = Object.keys(src[0]).map(e => {
				return {name:e, field:e}
			})
		}
		setData(src);
		// setData(src.reverse());

	}, [props.source])


	const onSelect = e => {
		if (props.selectable === false) return

		// setSelected(s => e === s? -1 : e);
		if (e === selected) e = -1
		setSelected(e)
		if (e !== -1) props.onSelect?.(data[e])
	}


	let template = cols.current.length?
		'30px ' + cols.current.map(e => e.width || 'auto').join(' ') : ''

	return <div id={props.id} className='ui2-table' style={{gridTemplateColumns:template}}>
		{props.header !== false &&
			<div className='ui2-table-header'>
				<div className='ui2-table-nr'>#</div>
				{cols.current.map((c, i) => <div key={i}>{
					typeof c === 'object'? (c.name || c.label || c.id || c.field || '???') : c
				}</div>)}
			</div>
		}
		<div className='ui2-table-list'>
			{data.map((e, i) => <TableRow
				key={i}
				index={i}
				selected={i === selected}
				data={e}
				columns={cols.current}
				onClick={e => onSelect(i)}
			/>)}
			{(props.children && selected >= 0) && <div
					className='ui2-table-child'
					style={{gridColumn:'1 / span ' + (cols.current.length + 1), gridRow:selected + 3}}
					>
					{typeof props.children === 'function'?
						React.createElement(props.children, {data:data[selected]})
						:
						React.cloneElement(props.children, {data:data[selected]})
					}
				</div>
			}
		</div>
	</div>
}


// ---------------------------------------------------------------------------- TableRow
const TableRow = ({index, selected, data, columns, onClick}) => {

	return <div className={'ui2-table-row' + (selected? ' selected' : '')} onClick={onClick}>
		<div className='ui2-table-nr'>{index+1}</div>

		{/* <div>{index + 1}</div> */}


		{columns.map((c, j) =>
			<div key={j}>{
				c.name === 'nr.'? index + 1 :
				c.format? c.format(data[c.field], data) :
					getField(data, c.field || c.name || c) ?? (c.default || '???')
			}</div>
		)}
	</div>
}


// ---------------------------------------------------------------------------- getField
const getField = (data, field) => {
	if (typeof field !== 'string') return

	if (field && field.includes('.')){
		let path = field.split('.');
		path.forEach(e => data = data?.[e])
		return data;

	}else return data[field];
}


/* ---sample:
	...
	return (
		<TableView id='ccxt-strategie-table'
			columns={[
				'id',
				'numTrades',
				'amountMax',
				'duration',
				{label:'test', format:numberFormat, default:'---'},
				{field:'pnl', format:numberFormat},
				'profit',
				{label:'time', format:dateFormat}
			]}
			source={props.source?.cycles}
			onSelect={onSelect}
			>
			<SubTable />
		</TableView>
	)
}

const numberFormat = e => e?.toFixed(3)
const dateFormat = (e, data) => data.startTimeStr + ' - ' + data.closeTimeStr


const SubTable = props => {
	return (
		<TableView
			header={false}
			selectable={false}
			source={props.data.trades}
		/>
	)
}
*/
